// Components/Services/FullHomeRemodel/FullHomeRemodelPage.jsx
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import HomeRemodelOverview from "./HomeRemodelOverview";
import HomeRemodelWhoItsFor from "./HomeRemodelWhoItsFor";
import HomeRemodelProcess from "./HomeRemodelProcess";
import FinalCTA from "../HomePage/FinalCTA";
import HomeRemodelPortfolio from "./HomeRemodelPortfolio";
import WhoWeAre from "../AboutUs/WhoWeAre";
import Overview from "../ADU&newcustomhome/OverView";
import HOACommercialOverview from "../HOACommercial/HOACommercialOverview";
import TakeoverProjectsOverview from "../TakeoverProjects/TakeoverProjectsOverview";
import ADUPortfolio from "../ADU&newcustomhome/ADUPortfolio";
import HomeRemodelOtherServices from "./HomeRemodelOtherServices";
import HOAPortfolio from "../HOACommercial/HOAPortfolio";

export default function FullHomeRemodelPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Full Home Remodels | Ashlar Building Group</title>
        <meta
          name="description"
          content="Ashlar Building Group handles complete home remodels across California — kitchens, bathrooms, additions, and full interior renovations. Precision craftsmanship from a third-generation construction firm."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.ashlarbuildinggroup.com/services/full-home-remodels" />
        <meta property="og:title" content="Full Home Remodels | Ashlar Building Group" />
        <meta
          property="og:description"
          content="Complete home remodels handled professionally from concept to completion. Third-generation craftsmanship, transparent process, and zero shortcuts."
        />
        <meta property="og:image" content="/Images/full-house-remodel.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.ashlarbuildinggroup.com/services/full-home-remodels" />
      </Helmet>

      <HeroSection />
      <HomeRemodelOverview/>
      <HomeRemodelPortfolio/>
      <HomeRemodelWhoItsFor/>
      <HomeRemodelProcess/>
      <HomeRemodelOtherServices/>
      <Overview/>
      <ADUPortfolio/>
      <HOACommercialOverview/>
      <HOAPortfolio/>
      <TakeoverProjectsOverview/>
      <WhoWeAre/>
      <FinalCTA/>
    </>
  );
}